import { AppShell } from "@/components/app/AppShell";
import { PublicShell } from "@/components/site/PublicShell";
import { useAuth } from "@/context/AuthContext";
import { CvLocalNav } from "./CvLocalNav";

// Wspólny layout działu CV: gość → publiczny layout, zalogowany → layout aplikacji.
// Lokalna nawigacja kontekstowa pokazywana na stronach sekcji (nie na landingu).
export const CvShell = ({ children, active, showNav = true }) => {
  const { user } = useAuth();
  const Outer = user ? AppShell : PublicShell;
  return (
    <Outer>
      <div data-testid="cv-shell" className="mx-auto max-w-content">
        {showNav && <CvLocalNav active={active} />}
        {children}
      </div>
    </Outer>
  );
};
